import { Bike, Banknote, Clock3 } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";
import { RecruitmentForm } from "./RecruitmentForm";

const perks = [
  { icon: Clock3, text: "Flexible hours — pick your own shifts" },
  { icon: Banknote, text: "Weekly pay, keep 100% of your tips" },
  { icon: Bike, text: "Car, bike, or on foot — your call" },
];

export const Recruitment = () => (
  <section id="drive" className="px-6 py-12 md:px-12 lg:py-20">
    <div className="mx-auto max-w-[1400px] overflow-hidden rounded-[2.5rem] bg-forest">
      <div className="grid grid-cols-1 gap-16 p-10 md:p-16 lg:grid-cols-12 lg:p-24">
        <div className="lg:col-span-6">
          <Reveal>
            <Chapter number="05" label="Join the Fleet" light />
            <h2 className="mt-6 font-syne text-4xl font-extrabold leading-[1.02] tracking-tighter text-bone sm:text-5xl lg:text-6xl">
              Tired of waiting hours for groceries?
              <br />
              <span className="text-fresh">So are we.</span>
            </h2>
            <p className="mt-8 max-w-md text-base leading-relaxed text-bone/70 md:text-lg">
              Help us change the game in Calgary. Join the crew of pickers and
              drivers working in perfect sync — and get paid to keep the city
              moving fast.
            </p>
          </Reveal>
          <div className="mt-12 space-y-5">
            {perks.map((p, i) => (
              <Reveal key={p.text} delay={0.15 + i * 0.1}>
                <div className="flex items-center gap-4">
                  <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-fresh/15">
                    <p.icon className="h-5 w-5 text-fresh" />
                  </span>
                  <p className="text-sm font-semibold text-bone/90 md:text-base">{p.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={0.2} className="lg:col-span-6">
          <RecruitmentForm />
        </Reveal>
      </div>
    </div>
  </section>
);
